import {
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  FileOutlined,
  FolderOpenFilled,
  PlusOutlined,
  QuestionCircleOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import FolderIcon from "@src/styles/icon/folder-icon.svg";
import {
  Button,
  Col,
  Descriptions,
  Empty,
  Input,
  Modal,
  Row,
  Tree,
} from "antd";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { EquipmentMasterApi } from "../../../api/backend/equipmentMaster";
import KBN from "../../../api/backend/kbn";
import TitlePage from "../../../component/Desktop/titlePage";
import FooterPage from "../../../component/footer/footerPage";
import SelectWithLabel from "../../../component/FormInput/SelectWithLabel";
import SplitComponent from "../../../component/split-component/SplitComponent";
import {
  COMMON_CONSTANT,
  KEY,
  lang,
  MODE_SCREEN,
  STYLE,
} from "../../../constants/common.const";
import {
  formatString,
  handleCatchError,
  showMessage,
} from "../../../constants/utils";
import classDdl from "../../../models/control/dropdownlist";
import classText from "../../../models/control/text";
import "./equipmentMaster.scss";
import Loading from "../../../component/Desktop/loading/loading";
import { useSelector } from "react-redux";
import { isEmptyData } from "../../../utils/helper";
import rolesConst from "../../../routers/roles/roles.const";
const { DirectoryTree } = Tree;

const getSubChild = (code) => {
  return Array.from({ length: 3 }).map((_, index) => ({
    code: index + 1,
    title: lang.SUB_DIVISION_CATEGORY + " " + (index + 1),
  }));
};

const ORDER_TREE = {
  EQUIPMENT: 0,
  MAIN: 1,
  SUB: 2,
  SMALL: 3,
  SUB_DIVISION: 4,
};
const transformData = (data, parentKey = "", expandedKeys = []) => {
  return data.map((item, index) => {
    const eachKey =
      item.itemCode !== "" &&
      item.itemCode !== null &&
      item.itemCode !== undefined
        ? item.itemCode + "-" + item.id
        : item.typeKey;
    const key = parentKey !== "" ? `${parentKey}-${eachKey}` : `${eachKey}`;
    // const key = item.id || item.typeKey
    const type = !item.type ? ORDER_TREE.EQUIPMENT : Number(item.type);

    const isOpen = expandedKeys.includes(key);
    const hasChildren =
      Array.isArray(item.children) && item.children.length > 0;
    const order = item.type ? Number(item.type) : 0;
    const name = item.typeName || item.itemName;
    return {
      title: (
        <span
          style={{
            marginLeft: 5,
          }}
        >
          {name}
        </span>
      ),
      name: name,
      key: key,
      code: item.itemCode || item.typeKey,
      id: item.id || item.typeKey,
      order: type,
      typeName: item.typeName || "",
      machineClassification: item.typeKey || "",
      position: item.displayOrder,
      icon: hasChildren ? (
        !isOpen ? (
          <img
            style={{ width: 20, height: 20 }}
            src={FolderIcon}
            alt=""
            className="icon__confirm"
          />
        ) : (
          <FolderOpenFilled style={{ color: "#0080cb", fontSize: 23 }} />
        )
      ) : (
        <FileOutlined style={{ fontSize: 16 }} />
      ),
      isLeaf: !hasChildren,
      children: hasChildren
        ? transformData(item.children, key, expandedKeys)
        : order != 4
        ? []
        : undefined,
    };
  });
};

const ListEquipmentMaster = () => {
  const categoryDataOrigin = {
    title: new classText(""),
    code: new classText(""),
    position: new classText(""),
    order: 1,
    ancestors: [],
    typeName: "",
    parentId: "",
  };
  const [maxSize, setMaxSize] = useState(window.innerWidth - 400);
  const { collapsed } = useSelector((state) => state.sideBar);

  const [loading, setLoading] = useState(false);
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [dataCategory, setDataCategory] = useState(categoryDataOrigin);

  const [mode, setMode] = useState(MODE_SCREEN.VIEW);
  const [currentNode, setcurrentNode] = useState({});
  const [listParent, setListParent] = useState([]);

  const [data, setData] = useState([]);
  const [originData, setOriginData] = useState([]);
  const treeData = transformData(data, "", expandedKeys);
  const treeOrigin = transformData(originData, "", []);
  const [selectedKeys, setSelectedKeys] = useState([]);

  const [filterTree, setFilterTree] = useState(new classDdl(""));
  const [isFillData, setIsFillData] = useState(false);
  const [editData, setEditData] = useState(null);
  const [disabledEdit, setDisabledEdit] = useState(false);

  const {roles} = useSelector(state => state.auth)
  const isLead  = roles === rolesConst.HEAD_OFFICE_ADMIN 
  // GET PARENT KEY
  function findParent(data, targetKey, path = []) {
    for (const item of data) {
      const currentPath = [...path, item];
      if (item.key === targetKey) {
        return path;
      }
      if (item.children) {
        const result = findParent(item.children, targetKey, currentPath);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  // FIND ITEM BY KEY
  function findItemByKey(data, targetKey) {
    for (const item of data) {
      if (item.key === targetKey) {
        return item;
      }
      if (item.children) {
        const found = findItemByKey(item.children, targetKey);
        if (found) return found;
      }
    }
    return null;
  }

  const getDetailNodeById = async (id) => {
    try {
      setLoading(true);
      const res = await EquipmentMasterApi.getEquipmentCateById(id);
      const data = res.data;
      const newData = {
        title: data.itemName,
        code: data.itemCode,
        order: Number(data.type),
        position: data.displayOrder,
        ancestors: data.ancestors || [],
        typeName: data.typeName,
        parentId: data.parentId,
      };
      const parentsNode = findParent(treeData, currentNode.key);
      setDataCategory({
        ...dataCategory,
        title: {
          ...dataCategory.title,
          value: newData.title,
          error: false,
          message: "",
        },
        code: {
          ...dataCategory.code,
          value: newData.code,
          error: false,
          message: "",
        },
        position: {
          ...dataCategory.position,
          value: newData.position,
          error: false,
          message: "",
        },
        order: newData.order,
        ancestors: newData.ancestors,
        typeName: newData.typeName,
        parentId: newData.parentId,
      });
      setcurrentNode({
        ...data,
        order: Number(data.type),
        name: data.itemName,
        code: data.itemCode,
        position: data.displayOrder,
        ancestors: data.ancestors || [],
      });
      setListParent(parentsNode);
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoading(false);
    }
  };

  // Handle select
  const onSelect = async (keys, info) => {
    setSelectedKeys(keys);
    setMode(MODE_SCREEN.VIEW);
    const currentNode = info.node;
    const id = currentNode.id;
    const type = currentNode.order;
    if (type == ORDER_TREE.EQUIPMENT) {
      setcurrentNode({
        ...currentNode,
      });

      return;
    }
    try {
      setLoading(true);
      const res = await EquipmentMasterApi.getEquipmentCateById(id);
      const data = res.data;
      const newData = {
        title: data.itemName,
        code: data.itemCode,
        order: Number(data.type),
        position: data.displayOrder,
        ancestors: data.ancestors || [],
        typeName: data.typeName,
        parentId: data.parentId,
      };
      const parentsNode = findParent(treeData, currentNode.key);
      setDataCategory({
        ...dataCategory,
        title: {
          ...dataCategory.title,
          value: newData.title,
          error: false,
          message: "",
        },
        code: {
          ...dataCategory.code,
          value: newData.code,
          error: false,
          message: "",
        },
        position: {
          ...dataCategory.position,
          value: newData.position,
          error: false,
          message: "",
        },
        order: newData.order,
        ancestors: newData.ancestors,
        typeName: newData.typeName,
        parentId: newData.parentId,
      });
      setcurrentNode({
        ...data,
        order: Number(data.type),
        name: data.itemName,
        code: data.itemCode,
        position: data.displayOrder,
        ancestors: data.ancestors || [],
      });
      setListParent(parentsNode);
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoading(false);
    }
  };

  function isRegex(a) {
    return a instanceof RegExp;
  }

  // Change Input
  const changeData = (key, value, rule) => {
    if (rule && isRegex(rule)) {
      if (!rule.test(value)) {
        return;
      }
    }
    setIsFillData(true);
    setDataCategory({
      ...dataCategory,
      [key]: { ...dataCategory[key], value },
    });
  };

  // HANDLE EXPAND TREE
  const handleExpand = (expandedKeysValue, { node }) => {
    if (mode === MODE_SCREEN.ADD || mode === MODE_SCREEN.EDIT || loading) {
      return;
    }
    onSelect([node.key], { node });
    setExpandedKeys(expandedKeysValue);
  };

  function findNodeById(tree, targetId) {
    for (const node of tree) {
      if (node.id === targetId) {
        return node;
      }
      if (node.children) {
        const found = findNodeById(node.children, targetId);
        if (found) return found;
      }
    }
    return null;
  }

  // CLICK ADD _ EDIT
  const handleClickAddEdit = (m = "ADD") => {
    setMode(MODE_SCREEN[m]);
    if (m === "ADD") {
      const currentKey = currentNode.key;
      let node;
      let newCode = "01";
      if (currentNode) {
        node = findNodeById(treeData, currentNode.id);
        if (
          node &&
          node.children &&
          Array.isArray(node.children) &&
          node.children.length
        ) {
          const listCodeOfChilren = node.children.map((i) => Number(i.code));
          newCode = Number(Math.max(...listCodeOfChilren)) + 1;
          newCode = newCode < 10 ? "0" + newCode : newCode;
        }
      }

      setDataCategory({
        ...dataCategory,
        title: { ...dataCategory.title, value: "" },
        code: { ...dataCategory.code, value: newCode },
        position: {
          ...dataCategory.code,
          value: "",
        },
        parentId: currentNode.id,
      });
    }
    else{
      setEditData(JSON.parse(JSON.stringify(dataCategory)));
      setDisabledEdit(true);
    }
  };
  // Popup common
  const showConfirmMessage = (
    msg,
    callbackOK,
    callbackCancel,
    typeInfo = false
  ) => {
    let ok, cancel;
    const callBackDefault = () => {
      Modal.destroyAll();
    };

    // Callback OK exist
    if (callbackOK) {
      ok = () => {
        callbackOK();
        callBackDefault();
      };
    }
    // Callback Cancel exist
    if (callbackCancel) {
      cancel = () => {
        callbackCancel();
        callBackDefault();
      };
    }

    Modal.confirm({
      centered: true,
      icon: <QuestionCircleOutlined />,
      title: lang.CONFIRM,
      content: msg,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onCancel: cancel || callBackDefault,
      onOk: ok || callBackDefault,
    });
  };

  // Validate Data

  const validate = () => {
    let flagError = false;
    let currentCodeObj = dataCategory.code;
    let currentTitleObj = dataCategory.title;
    let currentPositionObj = dataCategory.position;
    let maxPosition = currentNode.children && currentNode.children.length + 1;
    const title = String(currentTitleObj.value).trim();
    const code = String(currentCodeObj.value).trim();
    let position = String(currentPositionObj.value).trim();

    // Check empty
    if (!title) {
      flagError = true;
      currentTitleObj.error = true;
    } else {
      currentTitleObj.error = false;
    }
    if (!code) {
      flagError = true;
      currentCodeObj.error = true;
    } else {
      currentCodeObj.error = false;
    }
    if (!position && mode === MODE_SCREEN.EDIT) {
      flagError = true;
      currentPositionObj.error = true;
    } else {
      currentPositionObj.error = false;
    }

    setDataCategory({
      ...dataCategory,
      title: currentTitleObj,
      code: currentCodeObj,
      position: currentPositionObj,
    });
    return !flagError;
  };

  // SAVE
  const handleSave = () => {
    if (!validate()) {
      return;
    }
    showConfirmMessage(
      mode === MODE_SCREEN.ADD
        ? COMMON_CONSTANT.BOM_C008
        : COMMON_CONSTANT.BOM_C009,
      saveData
    );
  };

  const onCancel = () => {
    setMode(MODE_SCREEN.VIEW);
    setDataCategory({
      ...dataCategory,
      title: {
        ...dataCategory.title,
        value: currentNode.name,
        error: false,
        message: "",
      },
      code: {
        ...dataCategory.code,
        value: currentNode.code,
        error: false,
        message: "",
      },
    });
    setIsFillData(false);
  };
  // CANCEL
  const handleCancel = () => {
    if (isFillData) {
      Modal.confirm({
        centered: true,
        icon: <QuestionCircleOutlined />,
        title: lang.CONFIRM,
        content: COMMON_CONSTANT.BOM_C018,
        okText: lang.OK,
        cancelText: lang.CANCEL,
        onOk: onCancel,
      });
    } else {
      onCancel();
    }
  };

  // DELETE
  const showMessageDeleteConfirm = () => {
    // Action del
    const funcDel = async () => {
      try {
        await EquipmentMasterApi.deleteEquipmentCate(currentNode.id);
        showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C004);
        getTreeData();
        setcurrentNode({});
        setDataCategory(categoryDataOrigin);
      } catch (error) {
        handleCatchError(error);
      }
    };

    Modal.confirm({
      icon: <QuestionCircleOutlined />,
      title: lang.DELETE,
      content: COMMON_CONSTANT.BOM_C001,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onOk: funcDel,
      centered: true,
    });
  };

  const getvalue = (order, type = "name") => {
    if (!currentNode) return;
    if (currentNode.order == ORDER_TREE.EQUIPMENT) {
      if (order == ORDER_TREE.EQUIPMENT) {
        return currentNode.name;
      }
    }
    if (currentNode.order == order && mode === MODE_SCREEN.ADD) {
      return currentNode[type];
    }
    if (
      (currentNode.order == order && mode !== MODE_SCREEN.ADD) ||
      (Number(currentNode.order) + 1 == Number(order) &&
        mode === MODE_SCREEN.ADD)
    ) {
      const exactType = type === "name" ? "title" : type;
      return dataCategory[exactType] && dataCategory[exactType].value;
    }
    if (currentNode.order < order) {
      return "";
    }

    // render list parent
    const listParent = currentNode.ancestors || [];
    const subCode = currentNode.order - order;
    const node = listParent[listParent.length - subCode];
    const finalType = type === "name" ? "itemName" : "itemCode";
    return node ? node[finalType] : "";
  };

  const isInput = (order) => {
    if (!currentNode) return false;
    if (mode === MODE_SCREEN.VIEW) return false;
    if (mode === MODE_SCREEN.ADD) return order == currentNode.order + 1;
    if (mode === MODE_SCREEN.EDIT) return order == currentNode.order;
  };

  const currentOrder =
    currentNode && (currentNode.order || currentNode.order == 0)
      ? mode === MODE_SCREEN.ADD
        ? currentNode.order + 1
        : currentNode.order
      : 0;
  const hideValue =
    (!currentNode || currentNode.order == ORDER_TREE.EQUIPMENT) &&
    mode === MODE_SCREEN.VIEW;

  const listView = [
    {
      title: "工種",
      value: currentNode && currentNode.typeName,
      key: "title",
      span: 5,
      isInput: false,
    },
    {
      title: lang.EQUIP_CLASS_LARGE_NAME,
      value: getvalue(ORDER_TREE.MAIN, "code"),
      key: "code",
      rule: /^(\d{1,2})?$/,
      error: dataCategory.code.error,
      messError: dataCategory.code.message,
      required: isInput(ORDER_TREE.MAIN),
      isInput: isInput(ORDER_TREE.MAIN),
      disabled: mode === MODE_SCREEN.EDIT,
      span: 1,
      order: ORDER_TREE.MAIN,
    },
    {
      title: lang.MAIN_CATEGORY_NAME,
      value: getvalue(ORDER_TREE.MAIN, "name"),
      key: "title",
      rule: /^.{0,255}$/,
      error: dataCategory.title.error,
      messError: dataCategory.title.message,
      required: isInput(ORDER_TREE.MAIN),
      isInput: isInput(ORDER_TREE.MAIN),
      hideTitle: true,
      span: 4,
    },
    {
      title: lang.EQUIP_CLASS_MIDDLE_NAME,
      value: getvalue(ORDER_TREE.SUB, "code"),
      key: "code",
      rule: /^(\d{1,2})?$/,
      error: dataCategory.code.error,
      messError: dataCategory.code.message,
      required: isInput(ORDER_TREE.SUB),
      isInput: isInput(ORDER_TREE.SUB),
      disabled: mode === MODE_SCREEN.EDIT,
      span: 1,
      order: ORDER_TREE.SUB,
    },
    {
      title: lang.SUB_CATEGORY_NAME,
      value: getvalue(ORDER_TREE.SUB, "name"),
      key: "title",
      rule: /^.{0,255}$/,
      error: dataCategory.title.error,
      messError: dataCategory.title.message,
      required: isInput(ORDER_TREE.SUB),
      isInput: isInput(ORDER_TREE.SUB),
      hideTitle: true,
      span: 4,
    },
    {
      title: lang.EQUIP_CLASS_SMALL_NAME,
      value: getvalue(ORDER_TREE.SMALL, "code"),
      key: "code",
      rule: /^(\d{1,2})?$/,
      error: dataCategory.code.error,
      messError: dataCategory.code.message,
      required: isInput(ORDER_TREE.SMALL),
      isInput: isInput(ORDER_TREE.SMALL),
      disabled: mode === MODE_SCREEN.EDIT,
      span: 1,
      order: ORDER_TREE.SMALL,
    },
    {
      title: lang.SMALL_CATEGORY_NAME,
      value: getvalue(ORDER_TREE.SMALL, "name"),
      key: "title",
      rule: /^.{0,255}$/,
      error: dataCategory.title.error,
      messError: dataCategory.title.message,
      required: isInput(ORDER_TREE.SMALL),
      isInput: isInput(ORDER_TREE.SMALL),
      hideTitle: true,
      span: 4,
    },
    {
      title: lang.EQUIP_CLASS_DETAIL_NAME,
      value: getvalue(ORDER_TREE.SUB_DIVISION, "code"),
      key: "code",
      rule: /^(\d{1,2})?$/,
      error: dataCategory.code.error,
      messError: dataCategory.code.message,
      required: isInput(ORDER_TREE.SUB_DIVISION),
      isInput: isInput(ORDER_TREE.SUB_DIVISION),
      disabled: mode === MODE_SCREEN.EDIT,
      span: 1,
      order: ORDER_TREE.SUB_DIVISION,
    },
    {
      title: lang.SUB_DIVISION_CATEGORY_NAME,
      value: getvalue(ORDER_TREE.SUB_DIVISION, "name"),
      key: "title",
      rule: /^.{0,255}$/,
      error: dataCategory.title.error,
      messError: dataCategory.title.message,
      required: isInput(ORDER_TREE.SUB_DIVISION),
      isInput: isInput(ORDER_TREE.SUB_DIVISION),
      hideTitle: true,
      span: 4,
    },
    {
      title: lang.DISPLAY_ORDER,
      value: dataCategory.position.value,
      key: "position",
      rule: /^(\d{1,2})?$/,
      error: dataCategory.position.error,
      messError: dataCategory.position.message,
      isInput: mode !== MODE_SCREEN.VIEW,
      span: 2,
      disabled: true,
    },
  ];
  const renderListView = (
    <Descriptions  className="customEquipmentDes" size="small" column={5} bordered>
      {listView.map((cate, index) => (
        <React.Fragment key={cate.key}>
          <Descriptions.Item
            label={
              <>
                <span
                  style={{
                    color:
                      (currentOrder === cate.order && currentOrder != 0)
                        ? "#ff2255"
                        : "",
                  }}
                >
                  {cate.title}
                </span>
              </>
            }
            span={cate.span || 1}
            labelStyle={{
              width: "20%",
              fontWeight: "bold",
              display: cate.hideTitle && "none",
            }}
            contentStyle={{ padding: "8px 8px", width: 150 }}
          >
            {!cate.isInput ? (
              <span
              
              >
                {!hideValue ? cate.value : ""}
              </span>
            ) : (
              <div className="wrapErrorInput">
                <Input
                  onBlur={(e) => {
                    const value = String(e.target.value).trim();
                    if (cate.key === "code" && !isNaN(value) && Number(value) < 10 &&  Number(value) > 0 &&
                                            !isEmptyData(value)) {
                      changeData(cate.key, "0" + Number(value), cate.rule);
                    }
                  }}
                  className={(cate.error ? STYLE.BORDER_RED : "") + " w100 "}
                  onChange={(e) =>
                    changeData(cate.key, e.target.value, cate.rule)
                  }
                  disabled={cate.disabled}
                  value={cate.value}
                />
                {cate.error && (
                  <span style={{ color: "red", marginTop: 3 }}>
                    {cate.messError}
                  </span>
                )}
              </div>
            )}
          </Descriptions.Item>
        </React.Fragment>
      ))}
    </Descriptions>
  );

  // CHANGE FILTER TREE
  const handleChangeFilterTree = (value) => {
    setFilterTree({
      ...filterTree,
      value,
    });
   

  };
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  // API - GET TREE
  const getTreeData = async () => {
    try {
      const res = await EquipmentMasterApi.getTree({
        typeKey: filterTree.value,
      });
      setData(res.data);
      setOriginData(res.data);
    } catch (error) {
      handleCatchError(error);
    }
  };
  useEffect(() => {
    getTreeData();
  }, [filterTree.value]);

  // Get KBN
  useEffect(() => {
    KBN.getCategoryMachine2()
      .then((res) => {
        const listKbn = res.data.data;
        setFilterTree(new classDdl("", listKbn));
      })
      .catch((error) => {
        handleCatchError(error);
      });
  }, []);

  // API - SAVE
  async function saveData() {
    try {
      setLoadingScreen(true);
      const modeEdit = mode === MODE_SCREEN.EDIT;
      const isBigClass =
        currentNode && currentNode.order == ORDER_TREE.EQUIPMENT;
      const parentId =
        isBigClass && mode === MODE_SCREEN.ADD ? 0 : dataCategory.parentId;
      const dataPost = {
        itemCode: dataCategory.code.value,
        itemName: dataCategory.title.value,
        parentId,
        displayOrder: dataCategory.position.value,
        machineClassification: currentNode && currentNode.machineClassification,
        type: modeEdit
          ? Number(currentNode.order)
          : Number(currentNode.order) + 1,
      };
      if (modeEdit) {
        dataPost.id = currentNode.id;
      }
      modeEdit
        ? await EquipmentMasterApi.updateEquipmentCate(dataPost)
        : await EquipmentMasterApi.createEquipmentCate(dataPost);
      showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003, async () => {
        getTreeData();
        setMode(MODE_SCREEN.VIEW);
        // setcurrentNode({});
        // setDataCategory(categoryDataOrigin);
        setIsFillData(false);
        if (currentNode && currentNode.order != 0) {
          await getDetailNodeById(currentNode ? currentNode.id : "");
        }
      });
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoadingScreen(false);
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setMaxSize(collapsed ? window.innerWidth - 200 : window.innerWidth - 300);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setMaxSize(collapsed ? window.innerWidth - 200 : window.innerWidth - 300);
  }, [collapsed]);

 useEffect(() => {
    if (mode === MODE_SCREEN.EDIT && editData) {
      let isChange = false;
      ["title"].forEach((key) => {
        if (editData[key].value != dataCategory[key].value) {
          isChange = true;
        }
      });
      setDisabledEdit(!isChange);
    }
  }, [mode, editData, dataCategory.title]);
  return (
    <div className="des-content">
      <TitlePage name={lang.EQUIPMENT_MASTER} />

      <SplitComponent
        minSize={20}
        maxSize={maxSize}
        split="vertical"
        defaultSize="33%"
      >
        {/* LEFT: Tree */}
        <div
          className="equipment-tree-detail"
          style={{
            padding: 8,
            height: "100%",
            maxHeight: "100%",
            overflowY: "hidden",
          }}
        >
          <SelectWithLabel
            onChange={handleChangeFilterTree}
            value={filterTree.value}
            className="w100"
            options={filterTree.options}
            label={lang.TYPE_OF_WORK}
            disabled={
              mode === MODE_SCREEN.ADD || mode === MODE_SCREEN.EDIT || loading
            }
            allTitle={true}
          />
          <div
            className="mt20 pb10 pt10"
            style={{
              background: "#fff",
              minHeight: 150,
              maxHeight: "calc(100vh - 195px)",
              overflowY: "auto",
            }}
          >
            {treeData.length === 0 ? (
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            ) : (
              <DirectoryTree
                // key={JSON.stringify(data)}
                disabled={
                  mode === MODE_SCREEN.ADD ||
                  mode === MODE_SCREEN.EDIT ||
                  loading
                }
                onExpand={handleExpand}
                expandedKeys={expandedKeys}
                draggable
                onSelect={onSelect}
                treeData={treeData}
                selectedKeys={selectedKeys}
              />
            )}
          </div>
        </div>

        {/* RIGHT: View */}
        <div
          className="equipment-tree-detail"
          style={{ padding: 8, background: "#fff", height: "100%" }}
        >
          {renderListView}
        </div>
      </SplitComponent>
      <FooterPage>
        {mode !== MODE_SCREEN.ADD && mode !== MODE_SCREEN.EDIT ? (
          <Row justify="end">
            <Col>
              <Button
                disabled={
                  _.isEmpty(currentNode) ||
                  currentNode.order == ORDER_TREE.SUB_DIVISION
                }
                onClick={() => handleClickAddEdit("ADD")}
                className="buttonPC button--info wAuto ml10"
              >
                <PlusOutlined />
                {lang.ADD}
              </Button>
            </Col>
            <Col>
              <Button
                disabled={
                  _.isEmpty(currentNode) ||
                  currentNode.order == ORDER_TREE.EQUIPMENT
                }
                onClick={() => handleClickAddEdit("EDIT")}
                className="buttonPC button--outline --todo-- wAuto ml15"
              >
                <EditOutlined />
                {lang.EDIT}
              </Button>
            </Col>
            <Col>
              <Button
                onClick={showMessageDeleteConfirm}
                disabled={
                  _.isEmpty(currentNode) ||
                  currentNode.order == ORDER_TREE.EQUIPMENT || !isLead
                }
                className={`buttonPC ${
                  !_.isEmpty(currentNode) &&
                  currentNode.order !== ORDER_TREE.EQUIPMENT && isLead
                    ? "button--error--outline"
                    : "button--outline --todo-- "
                } ml15`}
              >
                <DeleteOutlined />
                {lang.DELETE}
              </Button>
            </Col>
          </Row>
        ) : (
          <>
            <Row justify="end">
              <Col>
                <Button
                disabled={mode == MODE_SCREEN.EDIT && disabledEdit}
                  onClick={handleSave}
                  className="buttonPC button--info wAuto ml10"
                >
                  <SaveOutlined />
                  {lang.SAVE}
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={handleCancel}
                  className="buttonPC button--outline --todo-- wAuto ml15"
                >
                  <CloseCircleOutlined />
                  {lang.CANCEL}
                </Button>
              </Col>
            </Row>
          </>
        )}
      </FooterPage>
      <Loading show={loadingScreen} />
    </div>
  );
};

export default ListEquipmentMaster;
